<template>
  <div>
    <a-spin :spinning="loading">
      <div v-if="classSectionExamData">
        <!-- Exam Details -->
        <div class="row mb-2">
          <div class="col-12 col-md-6">
            <table class="table table-borderless table-sm mb-0">
              <tbody>
                <tr>
                  <th>Class</th>
                  <td>{{ classSectionExamData.school_class.name }}</td>
                </tr>
                <tr>
                  <th>Section</th>
                  <td>{{ classSectionExamData.section.name }}</td>
                </tr>
                <tr>
                  <th>Exam</th>
                  <td>{{ classSectionExamData.exam.name }}</td>
                </tr>
                <tr>
                  <th>Status</th>
                  <td>
                    <a-tag :color="classSectionExamData.declared ? 'green' : 'red'">{{ classSectionExamData.declared ? 'Declared' : 'Not declared' }}</a-tag>
                  </td>
                </tr>
                <tr>
                  <th>Grades</th>
                  <td>
                    <a-tag :color="classSectionExamData.grades ? 'green' : 'red'">{{ classSectionExamData.grades ? 'Enabled' : 'Disabled' }}</a-tag>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- <div class="col-6 col-md-4 text-right align-self-end">
            <a href="javascript:;" :class="[`${classSectionExamData.declared ? 'btn-primary' : 'btn-success'}`,'btn btn-sm btn-with-addon mr-2']"
              @click="handleDeclareExam('SINGLE')"
            >
              <span class="btn-addon">
                <i :class="['btn-addon-icon fe', `${classSectionExamData.declared ? 'fe-stop-circle' : 'fe-play-circle'}`]" />
              </span>
              {{ classSectionExamData.declared ? 'Re-Declare (Single Section)': 'Declare (Single Section)'}}
            </a>
          </div> -->
          <!-- <div class="col-6 col-md-2 text-right align-self-end">
            <a href="javascript:;" :class="[`${classSectionExamData.declared ? 'btn-primary' : 'btn-success'}`,'btn btn-sm btn-with-addon mr-2']"
               @click="handleDeclareExam('ALL-SECTIONS')"
            >
              <span class="btn-addon">
                <i :class="['btn-addon-icon fe', `${classSectionExamData.declared ? 'fe-stop-circle' : 'fe-play-circle'}`]" />
              </span>
              {{ classSectionExamData.declared ? 'Re-Declare (All Sections)': 'Declare (All Sections)'}}
            </a>
          </div> -->
          <div class="col-12 col-md-6 text-right align-self-end">
              <a href="javascript:;"
              class="btn btn-sm mr-2"
              :class="classSectionExamData && classSectionExamData.declared ? 'btn-danger' : 'btn-success'"
              @click="openDeclareDialog('DECLARE')">
              <i :class="classSectionExamData && classSectionExamData.declared ? 'fe fe-stop-circle' : 'fe fe-play-circle'"></i>
              {{ classSectionExamData && classSectionExamData.declared ? 'Undo Declare' : 'Declare' }}
              </a>
              <a href="javascript:;" class="btn btn-primary btn-sm" @click="openDeclareDialog('EVALUATION')">
              <i class="fe fe-bar-chart-2 mr-1"></i>
              Evaluation
              </a>
          </div>

        </div>
        <div class="mt-3">
          <a-collapse v-model="activeKey" accordion @change="handleCollapseChange">
            <a-collapse-panel header="Add Marks" key="1">
              <div class="row">
                <div class="col-12 col-md-4">
                  <p class="text-muted mb-0">Click on subject name to add marks</p>
                </div>
                <div class="col-12 col-md-8 mb-2 text-right">
                  <a-select v-model="selectedFilter" style="width: 150px" class="mr-2" placeholder="Filter by Failures">
                    <a-select-option value="all">All Students</a-select-option>
                    <a-select-option value="1">1 Failed Subject</a-select-option>
                    <a-select-option value="2">2 Failed Subjects</a-select-option>
                    <a-select-option value="3">3 Failed Subjects</a-select-option>
                    <a-select-option value="4">4 Failed Subjects</a-select-option>
                    <a-select-option value="4+">4+ Failed Subjects</a-select-option>
                  </a-select>
                  <a-button type="primary" ghost class="mr-2" @click="handleExportExcel">
                    <i class="fe fe-download mr-1"></i> Export
                  </a-button>
                  <bulk-upload-student-mark class="d-inline-block mr-2" :classSectionExamId="classSectionExamData.id" @created="handleSubjectMarkUpdate"/>
                  <bulk-upload-all-subject-marks class="d-inline-block" :classSectionExamId="classSectionExamData.id" @created="handleSubjectMarkUpdate"/>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <!-- Fixed Header Clone -->
                  <div class="fixed-header-wrapper" v-show="showFixedHeader" ref="fixedHeaderWrapper">
                    <table class="table table-bordered w-100 mb-0" ref="fixedTable" :style="{ width: tableScrollWidth + 'px' }">
                    </table>
                  </div>

                  <div class="scroll-area table-responsive" ref="scrollArea" @scroll="onTableScroll">
                    <table class="table table-bordered w-100">
                    <thead>
                      <tr>
                        <th style="width: 5%">Roll</th>
                        <th style="width: 7%;">S. Code</th>
                        <th style="width: 20%;">Name</th>
                        <th
                          class="neo-exam-marks-subjects-cell vertical-header"
                          v-for="column in examColumns"
                          :key="column.id"
                          @click="openMarksFormModal(column.subject)"
                        >
                          {{ column.label }}
                        </th>
                        <th
                          style="width: 8%; background: #f0f0f0; cursor: pointer; user-select: none; padding-right: 8px;"
                          @click="handleSort('total_mark')"
                          title="Click to sort"
                        >
                          <div class="d-flex align-items-center justify-content-between">
                            <span>Total</span>
                            <a-icon
                              v-if="sortKey === 'total_mark'"
                              :type="sortOrder === 'asc' ? 'caret-up' : 'caret-down'"
                              class="text-primary"
                            />
                          </div>
                        </th>
                        <th
                          style="width: 5%; background: #f0f0f0; cursor: pointer; user-select: none;"
                          @click="handleSort('section_rank')"
                          title="Click to sort"
                        >
                          <div class="d-flex align-items-center justify-content-between">
                            <span>Sec Rank</span>
                            <a-icon
                              v-if="sortKey === 'section_rank'"
                              :type="sortOrder === 'asc' ? 'caret-up' : 'caret-down'"
                              class="text-primary"
                            />
                           </div>
                        </th>
                        <th
                          style="width: 5%; background: #f0f0f0; cursor: pointer; user-select: none;"
                          @click="handleSort('class_rank')"
                          title="Click to sort"
                        >
                          <div class="d-flex align-items-center justify-content-between">
                            <span>Class Rank</span>
                            <a-icon
                              v-if="sortKey === 'class_rank'"
                              :type="sortOrder === 'asc' ? 'caret-up' : 'caret-down'"
                              class="text-primary"
                            />
                          </div>
                        </th>
                        <th style="width: 8%; background: #f0f0f0; cursor: pointer;" @click="openAttendanceFormModal">Attendance</th>
                        <th style="width: 15%; background: #f0f0f0; cursor: pointer;" @click="openRemarksFormModal">Remarks</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="enrollment in sortedStudents" :key="enrollment.id">
                        <th scope="row">{{ enrollment.roll_no }}</th>
                        <th scope="row">{{ enrollment.student_code }}</th>
                        <th scope="row" style="overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;">
                          <div class="d-flex align-items-center justify-content-between">
                            <div class="d-flex align-items-center">
                              <a v-if="enrollment.report_card_url" href="javascript:;" class="mr-2 text-primary" @click="downloadReportCard(enrollment.report_card_url)" title="Download Report Card">
                                <i class="fe fe-file-text"></i>
                              </a>
                              <span>{{ enrollment.student.first_name }} {{ enrollment.student.last_name }}</span>
                            </div>
                            <a-popover :title="enrollment.is_withheld ? 'Result Withheld' : 'Result Active'">
                              <template v-if="enrollment.is_withheld && enrollment.withheld_remark" slot="content">
                                <p class="mb-0"><strong>Remark:</strong> {{ enrollment.withheld_remark }}</p>
                              </template>
                              <a-switch
                                size="small"
                                :checked="!enrollment.is_withheld"
                                checked-children="Active"
                                un-checked-children="Inactive"
                                @change="(checked) => handleToggleWithhold(enrollment, checked)"
                              />
                            </a-popover>
                          </div>
                        </th>
                        <td v-for="column in examColumns" :key="column.id" class="px-2">
                          <div class="mark-cell-wrapper">
                            <a-icon
                              v-if="shouldShowLogIcon(enrollment.student_exam_mark, column.subject, column.type)"
                              type="info-circle"
                              class="info-icon"
                              @click="openActivityLog(enrollment.student_exam_mark, column.subject)"
                            />
                            <span :class="['mark-value', { 'text-danger': isMarkFailed(enrollment.student_exam_mark, column.subject, column.type) }]">{{ getStudentSubjectMark(enrollment.student_exam_mark, column.subject, column.type) }}</span>
                          </div>
                        </td>
                        <th scope="row" :class="{'text-danger': enrollment.student_exam[0] && enrollment.student_exam[0].status === 'Fail'}" style="background: #f0f0f0">
                          <span v-if="enrollment.student_exam[0] && getStudentTotalMark(enrollment) !== '--'">
                            {{ getStudentTotalMark(enrollment) }} / {{ getStudentFullMark(enrollment) }}
                            <br/>
                            <small :class="enrollment.student_exam[0].status === 'Fail' ? 'text-danger' : 'text-muted'">
                              ({{ getStudentPercentage(enrollment) }}%)
                            </small>
                          </span>
                          <span v-else>--</span>
                        </th>
                        <th scope="row" style="background: #f0f0f0">{{ enrollment.student_exam[0] ? enrollment.student_exam[0].section_rank : "--" }}</th>
                        <th scope="row" style="background: #f0f0f0">{{ enrollment.student_exam[0] ? enrollment.student_exam[0].class_rank : "--" }}</th>
                        <th scope="row" style="background: #f0f0f0">
                          <span v-if="enrollment.student_exam[0]">
                            {{ enrollment.student_exam[0].attendance !== null && enrollment.student_exam[0].attendance !== undefined ? enrollment.student_exam[0].attendance : "--" }} /
                            {{ enrollment.student_exam[0].total_school_days !== null && enrollment.student_exam[0].total_school_days !== undefined ? enrollment.student_exam[0].total_school_days : "--" }}
                            <br/>
                            <small class="text-muted">({{ enrollment.student_exam[0].attendance_percent !== null && enrollment.student_exam[0].attendance_percent !== undefined ? enrollment.student_exam[0].attendance_percent : "--" }}%)</small>
                          </span>
                          <span v-else>--</span>
                        </th>
                        <th scope="row" style="background: #f0f0f0">{{ (enrollment.student_exam_remark && enrollment.student_exam_remark[0]) ? enrollment.student_exam_remark[0].exam_remark : "--" }}</th>
                      </tr>
                      <tr v-if="!classSectionExamData.students.length">
                        <td :colspan="examColumns.length + 7">
                          <no-data text="No Students" />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  </div>
                  <!-- Fake Floating Horizontal Scrollbar -->
                  <div
                    class="floating-scrollbar"
                    v-show="showFloatingScrollbar"
                    ref="fakeScrollbar"
                    @scroll="onFakeScroll">
                    <div :style="{ width: tableScrollWidth + 'px', height: '1px' }"></div>
                  </div>
                </div>
              </div>
            </a-collapse-panel>
            <a-collapse-panel header="Exam Report" key="2" :disabled="false">
              <display-student-exam-report :examData="classSectionExamData"/>
            </a-collapse-panel>
          </a-collapse>
        </div>
      </div>
    </a-spin>

    <class-exam-marks-form @updated="handleSubjectMarkUpdate" />
    <class-exam-remarks-form @updated="handleSubjectMarkUpdate" />
    <class-exam-attendance-form @updated="handleSubjectMarkUpdate" />
    <activity-log-modal />
    <div>
    <a-modal
      v-model="declareDialogVisible"
      :title="dialogActionType === 'DECLARE' ? 'Declare Exam' : 'Evaluate Exam'"
      @cancel="declareDialogVisible = false"
      >
      <p>Choose how you want to proceed:</p>
      <template #footer>
      <template v-if="dialogActionType === 'EVALUATION'">
        <a-button @click="declareDialogVisible = false">Cancel</a-button>
        <a-button type="primary" @click="handleEvaluateExam('SINGLE')">Single Section</a-button>
        <a-button type="primary" @click="handleEvaluateExam('ALL-SECTIONS')">All Sections</a-button>
      </template>
      <template v-else>
      <a-button @click="declareDialogVisible = false">Cancel</a-button>
      <a-button type="primary" @click="handleDeclareExam('SINGLE')">Single Section</a-button>
      <a-button type="primary" @click="handleDeclareExam('ALL-SECTIONS')">All Sections</a-button>
      </template>
      </template>
      </a-modal>
  </div>
  </div>
</template>

<script>
import moment from 'moment'
import { omit, find } from 'lodash'

import ClassExamMarksForm from '@/components/exam/manage/Form/index'
import ClassExamRemarksForm from '@/components/exam/manage/Form/Remarks'
import ClassExamAttendanceForm from '@/components/exam/manage/Form/Attendance'
import ActivityLogModal from '@/components/exam/manage/ActivityLog/index'
import DisplayStudentExamReport from '@/components/exam/manage/Report/index'
import BulkUploadStudentMark from '@/components/exam/manage/Form/Bulk/index'
import BulkUploadAllSubjectMarks from '@/components/exam/manage/Form/BulkAllSubjects/index'

import NoData from '@/components/layout/NoData/index'

export default {
  name: 'DisplayClassSectionExamUpdated',
  components: {
    BulkUploadAllSubjectMarks,
    ClassExamMarksForm,
    ClassExamRemarksForm,
    ClassExamAttendanceForm,
    ActivityLogModal,
    DisplayStudentExamReport,
    NoData,
    BulkUploadStudentMark,
  },
  mounted: function() {
    this.getClassExamData()
    // Use capture: true so we catch scroll events even if a parent container is scrolling instead of window
    window.addEventListener('scroll', this.syncScrollComponents, { capture: true, passive: true })
    window.addEventListener('resize', this.syncScrollComponents, { passive: true })
    setTimeout(this.syncScrollComponents, 1000)
  },
  destroyed() {
    window.removeEventListener('scroll', this.syncScrollComponents, { capture: true })
    window.removeEventListener('resize', this.syncScrollComponents)
  },
  // props: ['classSectionExamData'],
  computed: {
    classSectionExamId: function () {
      return this.$route.params.id
    },
    examColumns: function () {
      if (!this.classSectionExamData) {
        return []
      }
      const columns = []
      this.classSectionExamData.class_section_exam_subject.forEach(subject => {
        if (subject.has_practical) {
          columns.push({
            label: `${subject.subject.abbreviation}-T`,
            subject: subject,
            type: 'theory',
            id: `${subject.id}-T`,
          })
          columns.push({
            label: `${subject.subject.abbreviation}-P`,
            subject: subject,
            type: 'practical',
            id: `${subject.id}-P`,
          })
          columns.push({
            label: subject.subject.abbreviation,
            subject: subject,
            type: 'total',
            id: `${subject.id}-Total`,
          })
        } else {
          columns.push({
            label: subject.subject.abbreviation,
            subject: subject,
            type: 'total',
            id: subject.id,
          })
        }
      })
      return columns
    },
    sortedStudents() {
      // Return empty array if data isn't loaded yet
      if (!this.classSectionExamData || !this.classSectionExamData.students) return []
      // Create a shallow copy so we don't mutate the original vuex/state array
      let students = [...this.classSectionExamData.students]

      // Filter by failed subject count
      if (this.selectedFilter !== 'all') {
        students = students.filter(student => {
          const studentExam = student.student_exam && student.student_exam.length > 0 ? student.student_exam[0] : null
          if (!studentExam) return false
          const failedCount = studentExam.failed_subject_count || 0
          if (this.selectedFilter === '4+') {
            return failedCount >= 4
          } else {
            return failedCount === parseInt(this.selectedFilter)
          }
        })
      }

      // Sort students based on sortKey and sortOrder
      if (this.sortKey) {
        students.sort((a, b) => {
          // Safely access the nested values
          const examA = a.student_exam && a.student_exam.length > 0 ? a.student_exam[0] : null
          const examB = b.student_exam && b.student_exam.length > 0 ? b.student_exam[0] : null

          let valA, valB
          // Handle Total Mark: If there's no total mark, set to -Infinity so it goes to the bottom
          if (this.sortKey === 'total_mark') {
            const markA = examA && (examA.fourth_subject_id && examA.total_mark_without_fourth_subject != null ? examA.total_mark_without_fourth_subject : examA.total_mark)
            const markB = examB && (examB.fourth_subject_id && examB.total_mark_without_fourth_subject != null ? examB.total_mark_without_fourth_subject : examB.total_mark)
            valA = markA != null ? parseFloat(markA) : -Infinity
            valB = markB != null ? parseFloat(markB) : -Infinity
          } else {
            // For other numeric keys (like ranks), set missing values to Infinity so they go to the bottom
            valA = examA && examA[this.sortKey] != null ? parseInt(examA[this.sortKey]) : Infinity
            valB = examB && examB[this.sortKey] != null ? parseInt(examB[this.sortKey]) : Infinity
          }
          if (valA < valB) return this.sortOrder === 'asc' ? -1 : 1
          if (valA > valB) return this.sortOrder === 'asc' ? 1 : -1
          return 0
        })
      }

      return students
    },
  },
  data: function() {
    return {
      loading: false,
      classSectionExamData: null,
      activeKey: ['1'],
      declareDialogVisible: false,
      dialogActionType: '', // 'DECLARE' or 'EVALUATION'
      sortKey: '',
      sortOrder: 'asc',
      selectedFilter: 'all',
      showFloatingScrollbar: false,
      showFixedHeader: false,
      tableScrollWidth: 0,
      headerCloned: false,
      activeScroller: null,
      scrollTimeout: null,
    }
  },
  methods: {
    moment,
    handleCollapseChange(key) {
      if (key === '1' || (Array.isArray(key) && key.includes('1'))) {
        setTimeout(this.syncScrollComponents, 300)
      }
    },
    onTableScroll(e) {
      // If something else is currently the active scroller, ignore this echoed event
      if (this.activeScroller && this.activeScroller !== 'table') return
      this.activeScroller = 'table'

      const scrollLeft = e.target.scrollLeft
      if (this.$refs.fakeScrollbar && this.showFloatingScrollbar) {
        this.$refs.fakeScrollbar.scrollLeft = scrollLeft
      }
      if (this.$refs.fixedHeaderWrapper && this.showFixedHeader) {
        this.$refs.fixedHeaderWrapper.scrollLeft = scrollLeft
      }

      // Release lock after scrolling stops
      clearTimeout(this.scrollTimeout)
      this.scrollTimeout = setTimeout(() => { this.activeScroller = null }, 50)
    },
    onFakeScroll(e) {
      if (this.activeScroller && this.activeScroller !== 'fake') return
      this.activeScroller = 'fake'

      const scrollLeft = e.target.scrollLeft
      if (this.$refs.scrollArea) {
        this.$refs.scrollArea.scrollLeft = scrollLeft
      }
      if (this.$refs.fixedHeaderWrapper && this.showFixedHeader) {
        this.$refs.fixedHeaderWrapper.scrollLeft = scrollLeft
      }

      clearTimeout(this.scrollTimeout)
      this.scrollTimeout = setTimeout(() => { this.activeScroller = null }, 50)
    },
    cloneHeader() {
      if (this.headerCloned) return
      const originalThead = this.$refs.scrollArea.querySelector('thead')
      if (!originalThead) return

      const clone = originalThead.cloneNode(true)
      const cloneThs = clone.querySelectorAll('th')
      const originalThs = originalThead.querySelectorAll('th')

      cloneThs.forEach((th, index) => {
        // Forward clicks to original header to maintain sorting logic
        th.addEventListener('click', () => {
          originalThs[index].click()
        })
      })

      this.$refs.fixedTable.appendChild(clone)
      this.headerCloned = true
    },
    updateCloneWidths() {
      if (!this.headerCloned) return
      const originalThs = this.$refs.scrollArea.querySelectorAll('thead th')
      const cloneThs = this.$refs.fixedTable.querySelectorAll('thead th')

      if (originalThs.length === cloneThs.length) {
        originalThs.forEach((th, i) => {
          const w = th.getBoundingClientRect().width
          cloneThs[i].style.width = w + 'px'
          cloneThs[i].style.minWidth = w + 'px'
          cloneThs[i].style.maxWidth = w + 'px'
        })
      }
    },
    syncScrollComponents(e) {
      // Ignore scroll events originating from our horizontal scrollers
      // because the window capture phase will intercept them and overwrite the scrollLeft values!
      if (e && e.target) {
        if (
          e.target === this.$refs.scrollArea ||
          e.target === this.$refs.fakeScrollbar ||
          e.target === this.$refs.fixedHeaderWrapper
        ) {
          return
        }
      }

      const scrollArea = this.$refs.scrollArea
      const fakeScrollbar = this.$refs.fakeScrollbar
      const fixedHeader = this.$refs.fixedHeaderWrapper
      if (!scrollArea) return

      const rect = scrollArea.getBoundingClientRect()
      const hasHorizontalScroll = scrollArea.scrollWidth > scrollArea.clientWidth
      this.tableScrollWidth = scrollArea.scrollWidth

      // --- 1. Fake Floating Horizontal Scrollbar ---
      if (fakeScrollbar) {
        const isBottomOffscreen = rect.bottom > window.innerHeight
        const isTopOnscreen = rect.top < window.innerHeight

        if (isBottomOffscreen && isTopOnscreen && hasHorizontalScroll) {
          this.showFloatingScrollbar = true
          fakeScrollbar.style.width = scrollArea.clientWidth + 'px'
          fakeScrollbar.style.left = rect.left + 'px'
          fakeScrollbar.scrollLeft = scrollArea.scrollLeft
        } else {
          this.showFloatingScrollbar = false
        }
      }

      // --- 2. Fixed Header Clone ---
      if (fixedHeader) {
        const offset = 0 // Native offset

        // Show fixed header if top of table is above offset, but bottom is still below offset
        if (rect.top < offset && rect.bottom > offset + 60) {
          if (!this.headerCloned) {
            this.cloneHeader()
          }
          this.showFixedHeader = true
          this.updateCloneWidths()

          fixedHeader.style.top = offset + 'px'
          fixedHeader.style.left = rect.left + 'px'
          fixedHeader.style.width = scrollArea.clientWidth + 'px'
          // Sync horizontal scroll exactly
          fixedHeader.scrollLeft = scrollArea.scrollLeft
        } else {
          this.showFixedHeader = false
        }
      }
    },
    handleSubjectMarkUpdate: function() {
      this.getClassExamData()
    },
    handleSort(key) {
      if (this.sortKey === key) {
        // If clicking the same column, toggle order or reset
        if (this.sortOrder === 'asc') {
          this.sortOrder = 'desc'
        } else {
          this.sortKey = null // Reset sort entirely after desc
          this.sortOrder = 'asc'
        }
      } else {
        // If clicking a new column, sort ascending
        this.sortKey = key
        this.sortOrder = 'asc'
      }
    },
    getClassExamData: function() {
      this.loading = true
      const currentKey = this.activeKey
      this.$http.get(`/api/classsectionexam/${this.classSectionExamId}`, {
        params: {
          with_students: 1,
          class_section_exam_id: this.classSectionExamId,
        },
      })
        .then(({ data }) => {
          this.classSectionExamData = data.data
          // Only update activeKey if nothing is selected yet
          if (!currentKey || currentKey.length === 0) {
            this.activeKey = data.data.declared ? ['2'] : ['1']
          } else {
            this.activeKey = currentKey
          }
          this.loading = false
          this.$nextTick(() => {
            setTimeout(this.syncScrollComponents, 500)
          })
        })
        .catch(error => {
          this.loading = false
          this.$neoNotify.error(error)
        })
    },
    getStudentSubjectMark: function(studentExamMarks, examSubject, type) {
      const studentExamMark = find(studentExamMarks, { subject_id: examSubject.subject.id })
      let mark = ''
      if (studentExamMark) {
        if (examSubject.grades_only) {
          if (studentExamMark.is_absent === 1 || studentExamMark.grade === 'Ab') return 'Ab'
          if (studentExamMark.is_absent === 2 || studentExamMark.grade === 'SL') return 'SL'
          mark = studentExamMark.grade ? studentExamMark.grade : '--'
        } else {
          switch (type) {
            case 'theory':
              if (studentExamMark.theory_is_absent === 1 || studentExamMark.theory_mark === 'Ab') return 'Ab'
              if (studentExamMark.theory_is_absent === 2 || studentExamMark.theory_mark === 'SL') return 'SL'
              mark = (studentExamMark.theory_mark || studentExamMark.theory_mark === 0) ? studentExamMark.theory_mark : '--'
              break
            case 'practical':
              if (studentExamMark.practical_is_absent === 1 || studentExamMark.practical_mark === 'Ab') return 'Ab'
              if (studentExamMark.practical_is_absent === 2 || studentExamMark.practical_mark === 'SL') return 'SL'
              mark = (studentExamMark.practical_mark || studentExamMark.practical_mark === 0) ? studentExamMark.practical_mark : '--'
              break
            default: // 'total'
              if (studentExamMark.is_absent === 1 || studentExamMark.mark === 'Ab') return 'Ab'
              if (studentExamMark.is_absent === 2 || studentExamMark.mark === 'SL') return 'SL'
              mark = (studentExamMark.mark || studentExamMark.mark === 0) ? studentExamMark.mark : '--'
              break
          }
        }
      } else {
        mark = '--'
      }

      return mark
    },
    isMarkFailed: function(studentExamMarks, examSubject, type) {
      const studentExamMark = find(studentExamMarks, { subject_id: examSubject.subject.id })
      if (!studentExamMark || examSubject.grades_only) {
        return false
      }
      if (type === 'total') {
        return studentExamMark.is_failed === 1
      }
      if (type === 'theory') {
        if (studentExamMark.theory_is_absent || studentExamMark.theory_mark === 'Ab') return true
        return (studentExamMark.theory_mark || studentExamMark.theory_mark === 0) && parseFloat(studentExamMark.theory_mark) < parseFloat(examSubject.theory_pass_mark)
      }
      if (type === 'practical') {
        if (studentExamMark.practical_is_absent || studentExamMark.practical_mark === 'Ab') return true
        return (studentExamMark.practical_mark || studentExamMark.practical_mark === 0) && parseFloat(studentExamMark.practical_mark) < parseFloat(examSubject.practical_pass_mark)
      }
      return false
    },
    getStudentTotalMark: function(enrollment) {
      const exam = enrollment.student_exam && enrollment.student_exam.length > 0 ? enrollment.student_exam[0] : null
      if (!exam) return '--'
      const total = (exam.fourth_subject_id && exam.total_mark_without_fourth_subject !== null && exam.total_mark_without_fourth_subject !== undefined)
        ? exam.total_mark_without_fourth_subject
        : exam.total_mark
      return (total !== null && total !== undefined) ? total : '--'
    },
    getStudentFullMark: function(enrollment) {
      const exam = enrollment.student_exam && enrollment.student_exam.length > 0 ? enrollment.student_exam[0] : null
      if (!exam) return '--'
      const full = (exam.fourth_subject_id && exam.total_full_mark_without_fourth_subject !== null && exam.total_full_mark_without_fourth_subject !== undefined)
        ? exam.total_full_mark_without_fourth_subject
        : exam.total_full_mark
      if (full !== null && full !== undefined) return full

      // Fallback from class_section_exam_subject if record has not been re-evaluated
      if (this.classSectionExamData && this.classSectionExamData.class_section_exam_subject) {
        const subjects = this.classSectionExamData.class_section_exam_subject.filter(s => s.is_in_total === 1 && !s.grades_only)
        const sum = subjects.reduce((acc, s) => acc + (parseFloat(s.full_mark) || 0), 0)
        if (sum > 0) return sum
      }
      return '--'
    },
    getStudentPercentage: function(enrollment) {
      const exam = enrollment.student_exam && enrollment.student_exam.length > 0 ? enrollment.student_exam[0] : null
      if (!exam) return '--'
      const pc = (exam.fourth_subject_id && exam.mark_percentage_without_fourth_subject !== null && exam.mark_percentage_without_fourth_subject !== undefined)
        ? exam.mark_percentage_without_fourth_subject
        : exam.mark_percentage
      return (pc !== null && pc !== undefined) ? pc : '--'
    },
    openMarksFormModal: function(subject) {
      if (this.classSectionExamData.students.length) {
        const examData = omit(this.classSectionExamData, ['class_section_exam_subject'])
        this.loading = true
        this.$http.get(`/api/classsectionexam/${examData.id}`, {
          params: {
            with_students: 1,
            class_section_exam_id: examData.id,
            subject_id: subject.subject.id,
          },
        })
          .then(({ data }) => {
            this.loading = false
            this.$eventBus.$emit('openClassExamMarksForm', subject, examData, data.data.students)
          })
          .catch(error => {
            this.loading = false
            this.$neoNotify.error(error)
          })
      } else {
        this.$message.warning('No students found to add marks for!')
      }
    },
    openRemarksFormModal: function() {
      if (this.classSectionExamData.students.length) {
        const examData = omit(this.classSectionExamData, ['class_section_exam_subject'])
        this.$eventBus.$emit('openClassExamRemarksForm', examData, this.classSectionExamData.students)
      } else {
        this.$message.warning('No students found to add remarks for!')
      }
    },
    openAttendanceFormModal: function() {
      if (this.classSectionExamData.students.length) {
        const examData = omit(this.classSectionExamData, ['class_section_exam_subject'])
        this.$eventBus.$emit('openClassExamAttendanceForm', examData, this.classSectionExamData.students)
      } else {
        this.$message.warning('No students found to add attendance for!')
      }
    },
    shouldShowLogIcon(studentExamMarks, examSubject) {
      const studentExamMark = find(studentExamMarks, { subject_id: examSubject.subject.id })
      return studentExamMark && studentExamMark.activities_count > 0
    },
    openActivityLog(studentExamMarks, examSubject) {
      const studentExamMark = find(studentExamMarks, { subject_id: examSubject.subject.id })
      if (studentExamMark && studentExamMark.id) {
        this.$eventBus.$emit('openMarkActivityLog', studentExamMark.id)
      }
    },
    openDeclareDialog(actionType) {
      this.dialogActionType = actionType
      this.declareDialogVisible = true
    },
    handleEvaluateExam(type) {
      this.loading = true
      const formData = {
        class_section_exam_id: this.classSectionExamId,
        type: type,
      }
      this.$http
        .patch('/api/evaluate-exam', formData)
        .then(() => {
          this.loading = false
          this.$notification.success({
            message: 'Successfully Evaluated',
            description: 'Exam evaluation completed successfully!',
          })
          this.getClassExamData()
          this.declareDialogVisible = false
        })
        .catch(error => {
          this.loading = false
          this.$neoNotify.error(error)
        })
    },

    handleDeclareExam(type) {
      this.loading = true
      const formData = {
        class_section_exam_id: this.classSectionExamId,
        type: type,
        is_undo_declare: this.classSectionExamData.declared ? 1 : 0,
      }
      this.$http
        .patch('/api/declareexam', formData)
        .then(() => {
          this.loading = false
          this.$notification.success({
            message: this.classSectionExamData.declared ? 'Successfully Undeclared' : 'Successfully Declared',
            description: this.classSectionExamData.declared
              ? 'Exam has been undeclared successfully!'
              : 'Exam has been declared successfully!',
          })
          this.getClassExamData()
          this.declareDialogVisible = false
        })
        .catch(error => {
          this.loading = false
          this.$neoNotify.error(error)
        })
    },

    handleToggleWithhold(enrollment, checked) {
      if (!checked) {
        // Switching to Inactive (Withheld)
        let remark = ''
        this.$confirm({
          title: 'Withhold student result',
          content: (h) => {
            return h('div', [
              h('p', `Are you sure you want to withhold the result for ${enrollment.student.first_name} ${enrollment.student.last_name}?`),
              h('a-textarea', {
                props: {
                  placeholder: 'Enter reason for withholding',
                  rows: 3,
                },
                on: {
                  change: (e) => {
                    remark = e.target.value
                  },
                },
              }),
            ])
          },
          onOk: () => {
            if (!remark || remark.trim() === '') {
              this.$message.error('Please provide a remark for withholding.')
              return Promise.reject(new Error('Remark is required'))
            }
            return this.updateWithholdStatus(enrollment.id, true, remark)
          },
        })
      } else {
        // Switching to Active (Released)
        this.$confirm({
          title: 'Release Withheld Result?',
          content: `Are you sure you want to release the result for ${enrollment.student.first_name} ${enrollment.student.last_name}?`,
          onOk: () => {
            this.updateWithholdStatus(enrollment.id, false)
          },
        })
      }
    },

    updateWithholdStatus(enrollmentId, isWithheld, remark = null) {
      this.loading = true
      const payload = {
        enrollment_id: enrollmentId,
        is_withheld: isWithheld ? 1 : 0,
      }
      if (isWithheld && remark) {
        payload.remark = remark
      }

      return this.$http.post(`/api/classsectionexam/${this.classSectionExamId}/withhold`, payload)
        .then(() => {
          this.loading = false
          this.$notification.success({
            message: 'Success',
            description: `Student result ${isWithheld ? 'withheld' : 'released'} successfully!`,
          })
          this.getClassExamData()
        })
        .catch(error => {
          this.loading = false
          this.$neoNotify.error(error)
        })
    },
    handleExportExcel() {
      this.loading = true
      this.$http.get('/api/reports/student/class-exam-results/export', {
        params: {
          session_id: this.classSectionExamData.session_id,
          class_id: this.classSectionExamData.school_class.id,
          section_id: this.classSectionExamData.section.id,
          exam_id: this.classSectionExamData.exam.id,
          status: 'All',
          failed_subject_filter: this.selectedFilter,
        },
        responseType: 'blob',
      })
        .then((response) => {
          this.loading = false
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url

          const contentDisposition = response.headers['content-disposition']
          let fileName = 'Exam_Results.xlsx'
          if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename="?([^"]+)"?/)
            if (fileNameMatch && fileNameMatch.length === 2) fileName = fileNameMatch[1]
          }

          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        })
        .catch((error) => {
          this.loading = false
          this.$neoNotify.error(error)
        })
    },
    downloadReportCard(url) {
      this.loading = true
      this.$http.get(url, {
        responseType: 'blob',
      })
        .then(async (response) => {
          this.loading = false
          const blob = response.data

          // Check if the response is JSON (means it's a redirect URL for S3)
          if (blob.type === 'application/json') {
            const text = await blob.text()
            try {
              const json = JSON.parse(text)
              if (json.url) {
                window.open(json.url, '_blank')
                return
              }
            } catch (e) {
              console.error('Failed to parse JSON from blob', e)
            }
          }

          // Otherwise, handle as direct file download (legacy or fallback)
          const blobURL = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = blobURL

          const contentDisposition = response.headers['content-disposition']
          let fileName = 'Report_Card.pdf'
          if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename="?([^"]+)"?/)
            if (fileNameMatch && fileNameMatch.length === 2) fileName = fileNameMatch[1]
          }

          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        })
        .catch((error) => {
          this.loading = false
          this.$neoNotify.error(error)
        })
    },
  },
}
</script>
<style scoped>
.vertical-header {
  writing-mode: vertical-rl; /* vertical top to bottom */
  transform: rotate(180deg); /* optional: flip text if needed */
  text-align: center;
  white-space: nowrap; /* prevent wrapping */
}
.mark-cell-wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4px 0;
}
.info-icon {
  position: absolute;
  top: -2px;
  right: -2px;
  font-size: 10px;
  color: #1890ff;
  cursor: pointer;
  transition: color 0.3s;
}
.info-icon:hover {
  color: #40a9ff;
}

.scroll-area {
  overflow-x: auto;
  overflow-y: visible;
  width: 100%;
}

.floating-scrollbar {
  position: fixed;
  bottom: 0;
  z-index: 1000;
  overflow-x: auto;
  overflow-y: hidden;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 -1px 4px rgba(0,0,0,0.1);
}

.fixed-header-wrapper {
  position: fixed;
  z-index: 1000;
  overflow: hidden;
  background: white;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}
.fixed-header-wrapper table {
  table-layout: fixed;
}
</style>
